import CDR from './CDR';

export { CDR };



// WEBPACK FOOTER //
// src/modules/screens/reporting/CDR/components/index.js